import { useMemo } from "react";
import type { SortDirection } from "../ui/DataTable/types";

export const useOrderBy = <T>(
  sortColumn: string,
  sortDirection: SortDirection,
  columnMapping: Record<string, { asc: T; desc: T }>,
  defaultValue: T,
): T => {
  return useMemo(() => {
    const mapping = columnMapping[sortColumn];
    if (!mapping || sortDirection === null) return defaultValue;
    return sortDirection === "asc" ? mapping.asc : mapping.desc;
  }, [sortColumn, sortDirection, columnMapping, defaultValue]);
};
